var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 78,
    viewBox: "0 0 76 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 64,
    height: 64,
    rx: 8,
    fill: "#34C347"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1316_17368)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 64,
    height: 64,
    rx: 8,
    fill: "white",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_17368)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4329 37.2492C36.8136 37.2497 39.1942 37.2497 41.5749 37.2492C42.3823 37.249 42.9324 37.2489 43.4129 37.3378C45.7129 37.7637 47.5136 39.6545 47.9191 42.0695C48.0039 42.574 48.0037 43.1517 48.0036 43.9995C48.0035 44.1842 48.0089 44.3703 47.9782 44.553C47.8566 45.2775 47.3163 45.8448 46.6263 45.9725C46.475 46.0006 46.3157 45.9997 46.2364 45.9992C40.7486 45.9684 35.2592 45.9684 29.7714 45.9992C29.6922 45.9997 29.5328 46.0006 29.3815 45.9725C28.6915 45.8448 28.1512 45.2775 28.0296 44.553C27.9989 44.3703 28.0043 44.1843 28.0042 43.9995C28.0041 43.1517 28.0039 42.574 28.0887 42.0695C28.4942 39.6545 30.295 37.7637 32.5949 37.3378C33.0754 37.2489 33.6255 37.249 34.4329 37.2492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.893 29.0826C31.893 25.5388 34.629 22.666 38.0039 22.666C41.3789 22.666 44.1148 25.5388 44.1148 29.0826C44.1148 32.6264 41.3789 35.4992 38.0039 35.4992C34.629 35.4992 31.893 32.6264 31.893 29.0826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8021 26.0291C28.2412 26.3179 26.2448 28.6567 26.2448 31.499C26.2448 33.9307 27.7061 35.9939 29.7319 36.7201C30.4953 36.2246 31.3585 35.8713 32.2907 35.6987C32.6413 35.6338 33.0088 35.6049 33.3881 35.5921C31.4565 34.107 30.2256 31.7193 30.2256 29.0823C30.2256 28.0085 30.4297 26.9761 30.8021 26.0291ZM32.5618 26.1591C34.7828 26.7512 36.4296 28.9174 36.4296 31.499C36.4296 32.7692 36.0309 33.9389 35.3613 34.87C33.3091 33.8353 31.8922 31.6325 31.8922 29.0823C31.8922 28.0294 32.1337 27.0358 32.5618 26.1591ZM27.8411 38.5005C27.4353 38.5047 27.1175 38.5201 26.8298 38.5749C24.9131 38.9399 23.4125 40.5606 23.0745 42.6306C23.0039 43.063 23.004 43.5582 23.0042 44.2849L23.004 44.3471C23.0036 44.4849 23.0031 44.6232 23.0253 44.7593C23.1267 45.3804 23.5769 45.8666 24.1519 45.9761C24.278 46.0001 24.4108 45.9993 24.4769 45.9989C25.2516 45.9945 26.0264 45.9907 26.8013 45.9878C26.597 45.6337 26.4544 45.2414 26.3851 44.8287C26.3322 44.5133 26.3351 44.1911 26.3365 44.0461L26.3368 43.9995L26.3368 43.8996C26.3364 43.1405 26.3361 42.4374 26.4442 41.7932C26.6489 40.5742 27.1368 39.4489 27.8411 38.5005ZM33.8303 45.9817C32.3642 45.9786 30.898 45.9783 29.4319 45.9806C29.4148 45.9782 29.3977 45.9754 29.3807 45.9722C28.6907 45.8445 28.1505 45.2772 28.0288 44.5527C28.0021 44.3939 28.0027 44.2326 28.0033 44.0717L28.0035 43.9992C28.0033 43.1514 28.0032 42.5737 28.0879 42.0692C28.3305 40.6245 29.0724 39.3673 30.1218 38.4992C31.5189 38.4993 32.916 38.4992 34.313 38.4989C34.9859 38.4987 35.4443 38.4986 35.8447 38.5749C37.7614 38.9399 39.262 40.5606 39.5999 42.6306C39.6705 43.063 39.6704 43.5582 39.6703 44.2849L39.6704 44.347C39.6709 44.4849 39.6714 44.6232 39.6492 44.7593C39.5478 45.38 39.0981 45.866 38.5236 45.9759C36.9592 45.9753 35.3947 45.9773 33.8303 45.9817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.205 45.9878C49.9799 45.9908 50.7548 45.9945 51.5297 45.999C51.5957 45.9993 51.7286 46.0001 51.8546 45.9761C52.4296 45.8666 52.8798 45.3804 52.9812 44.7594C53.0034 44.6232 53.0029 44.4849 53.0025 44.3471L53.0023 44.2849C53.0025 43.5582 53.0026 43.0631 52.932 42.6307C52.594 40.5606 51.0934 38.9399 49.1767 38.5749C48.8889 38.5201 48.5711 38.5048 48.1651 38.5005C48.8695 39.4489 49.3573 40.5742 49.562 41.7933C49.6702 42.4374 49.6699 43.1406 49.6695 43.8997L49.6694 43.9996L49.6698 44.0461V44.0461C49.6711 44.1912 49.6741 44.5134 49.6211 44.8288C49.5518 45.2414 49.4092 45.6337 49.205 45.9878ZM40.6451 34.8699C42.6973 33.8352 44.114 31.6325 44.114 29.0823C44.114 28.0295 43.8725 27.0359 43.4445 26.1592C41.2236 26.7514 39.5769 28.9175 39.5769 31.499C39.5769 32.7692 39.9755 33.9388 40.6451 34.8699ZM45.2041 26.0291C45.5766 26.9761 45.7807 28.0085 45.7807 29.0823C45.7807 31.7194 44.5497 34.107 42.6182 35.5921C42.9975 35.6049 43.3649 35.6338 43.7155 35.6987C44.6478 35.8713 45.511 36.2246 46.2744 36.7202C48.3004 35.994 49.7617 33.9308 49.7617 31.499C49.7617 28.6566 47.7652 26.3178 45.2041 26.0291ZM45.8844 38.4992C46.9338 39.3674 47.6758 40.6245 47.9184 42.0693C48.0031 42.5737 48.003 43.1514 48.0028 43.9992L48.0029 44.0717C48.0035 44.2326 48.0041 44.3939 47.9774 44.5528C47.8558 45.2773 47.3156 45.8445 46.6256 45.9723C46.6085 45.9754 46.5914 45.9782 46.5743 45.9807C45.1082 45.9783 43.642 45.9787 42.1759 45.9818C40.6116 45.9773 39.0472 45.9753 37.4829 45.9759C36.9084 45.866 36.4587 45.38 36.3573 44.7594C36.3351 44.6232 36.3356 44.4849 36.3361 44.3471L36.3362 44.2849C36.3361 43.5582 36.336 43.0631 36.4066 42.6307C36.7445 40.5606 38.2451 38.9399 40.1618 38.5749C40.5622 38.4987 41.0206 38.4988 41.6935 38.4989C43.0904 38.4993 44.4874 38.4994 45.8844 38.4992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6692 54.2577C48.4649 53.4657 55.4695 46.4617 56.2624 37.6663H57.9354C57.1334 47.3828 49.3859 55.1297 39.6692 55.9307V54.2577ZM36.3359 54.2575C27.5415 53.4644 20.5382 46.4608 19.7453 37.6663H18.0724C18.8742 47.3819 26.6204 55.1283 36.3359 55.9305V54.2575ZM19.7452 34.333H18.0723C18.8735 24.6168 26.62 16.8698 36.3359 16.0676V17.7405C27.5411 18.5337 20.5375 25.5379 19.7452 34.333ZM39.6692 17.7403C48.4653 18.5323 55.4702 25.537 56.2625 34.333H57.9355C57.1341 24.6159 49.3864 16.8684 39.6692 16.0674V17.7403ZM38.1192 15.9993C38.0808 15.9991 38.0423 15.999 38.0039 15.999C37.9654 15.999 37.9269 15.9991 37.8885 15.9993L38.1192 15.9993ZM58.0039 35.999C58.0039 36.076 58.0034 36.1528 58.0026 36.2295V35.7685C58.0034 35.8453 58.0039 35.9221 58.0039 35.999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 63,
    height: 63,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1316_17368",
    x: -6,
    y: -8,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1316_17368"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1316_17368",
    result: "effect2_dropShadow_1316_17368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1316_17368",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_17368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(18 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBIcon);
export default __webpack_public_path__ + "static/media/b_icon.77f3331c9a4cce8428b8ac11a22ecfec.svg";
export { ForwardRef as ReactComponent };